import config from 'SrcConfig'
import ApiCore from '../api-core'
import { NESHAN_API_KEY } from '@/constants/api-keys'

export default class Neshan extends ApiCore {
  constructor(store) {
    const baseUrl = 'https://api.neshan.org'
    const headers = {
      'Api-key': NESHAN_API_KEY
    }

    super(store, '', baseUrl, headers)
  }

  search(filter, showProgress) {
    return this._request({
      action: 'v1/search',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  reverse(filter, showProgress) {
    return this._request({
      action: 'v2/reverse',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  direction(filter, showProgress) {
    return this._request({
      action: 'v4/direction',
      method: 'GET',
      params: filter,
      showProgress
    })
  }
}
